import { TableView } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { useMemo } from "react";
import { UserStatusType } from "../../enums";

export type UserStatusLabelProps = {
  status?: string;
  statusId?: UserStatusType;
};
export const UserStatusLabel = ({ status = "NA", statusId = UserStatusType.ACTIVE }: UserStatusLabelProps) => {
  const color = useMemo(() => {
    switch (statusId) {
      case UserStatusType.ACTIVE:
        return "success.main";
      case UserStatusType.BLOCKED:
        return "error.main";
      default:
        return "text.disabled";
    }
  }, [statusId]);
  return <Typography color={color}>{status}</Typography>;
};
export default TableView;
